export default __webpack_public_path__ + "static/NotoSansThai-Regular.subset-8940cdcc30cceeea47dffa131a77822c.otf";